import React, { useEffect, useState, useMemo } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import TopHeader from "../Common/TopHeader";
import TableComponent from "../Common/TableComponent";
import FilterComponent from "../Common/FilterComponent";
import TooltipPositioned from "../Tooltip/TooltipPositioned";
import { GetApiMethod } from "../../core/services/apiService";
import constant from "../../core/constant";
import { CheckPropertyExistOrNot, formatLocData } from "../../core/services/sharedService";
import { useAppSelector } from "../../core/redux/hooks";
import { DtoAgentStatus } from "../../core/dto/dashboard.dto";

const Agentlist = () => {
    const [deleteMsg, setDeleteMsg] = useState<any>();
    const [deleteMsgtimeout, setDeleteMsgtimeout] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const [agentStatusListInfo, setAgentStatusListInfo] = React.useState<{ [index: string]: string }>({});
    const [data, setData] = useState<any>([]);

    // allAgentStatusDetails
    let authState = useAppSelector((state) => state.auth);
    const locationUrl = "tenant/location-crud";
    const [agentMappedLocationDetails, setAgentMappedLocationDetails] = useState([{
        name: "",
        id: null
    }]);

    const getAgentList = React.useCallback(async () => {
        const res = await GetApiMethod("tenant/agent-crud");
        setShowLoader(false);
        setData(res.data.data);
    }, []);



    useEffect(() => {
        getAgentList();
        GetApiMethod(locationUrl).then((res) => {
            let newArray = formatLocData(res.data.data);
            setAgentMappedLocationDetails((prevState) => [...newArray]);
        });
    }, [formatLocData, getAgentList]);

    React.useEffect(() => {
        const agentStatusList: { [index: string]: string } = {};
        if (authState.allAgentStatusDetails && authState.allAgentStatusDetails.length) {
            authState.allAgentStatusDetails.forEach((statusDetails: DtoAgentStatus) => {
                agentStatusList[statusDetails.email] = statusDetails.status;
            });
            setAgentStatusListInfo({ ...agentStatusList });
        }
    }, [authState.allAgentStatusDetails])

    const getLocationsAsCSV = (data: any) => {
        return data
            .map((item: any) => {
                return item.name;
            })
            .join(",");
    };

    const primaryAndSecondaryLocations = (priLocation: string, secLocations: string) => {
        return [...priLocation.split(","), ...secLocations.split(",")]
    }

    const columns: any = [
        {
            name: "Name",
            cell: (row: any) => (
                <div className="agent-status-table-list text-capitalize">
                    <span
                        className={
                            agentStatusListInfo[row.email] ?
                                agentStatusListInfo[row.email].toLowerCase() :
                                'offline'
                        }
                    ></span>
                    <span className="status-text">
                        {
                            row.name
                        }
                    </span>
                </div>
            ),
            selector: (row: any) => (CheckPropertyExistOrNot(row, 'name')),
            sortable: true,
        },
        {
            name: "Email",
            selector: (row: any) => row['email'],
            cell: (row: any) => (
                <div>
                    {TooltipPositioned({ 'placement': 'top', 'item': CheckPropertyExistOrNot(row, 'email') })}
                </div>
            ),
            sortable: true,
            style: {
                lineHeight: '1.4',
                paddingBottom: '3px',
                paddingTop: '3px'
            }
        },
        {
            name: "Display Name",
            selector: (row: any) => (CheckPropertyExistOrNot(row, 'display_name')),
            sortable: true,
        },
        {
            name: "Status",
            selector: (row: any) => ('isActive' in row ? (row.isActive ? "Active" : "Inactive") : "-"),
            sortable: true,
        },
        {
            name: "Primary Locations",
            selector: (row: any) => (
                <div>
                    {('primary_location' in row && row.primary_location.length > 0) ?
                        TooltipPositioned({
                            placement: "top",
                            item: getLocationsAsCSV(row.primary_location),
                        }) : "-"}
                </div>
            ),
        },
        {
            name: "Secondary Locations",
            selector: (row: any) => (
                <div>
                    {('secondary_location' in row && row.secondary_location.length > 0) ?
                        TooltipPositioned({
                            placement: "top",
                            item: getLocationsAsCSV(row.secondary_location),
                        }) : "-"}
                </div>
            ),
        },
        {
            name: "Actions",
            cell: (row: any) => (
                <div>
                    <Link
                        to={constant.AGENT_EDIT}
                        state={{
                            id: row._id,
                            names: row.name,
                            emails: row.email,
                            display_names: row.display_name,
                            is_active: row.isActive,
                            agentMappedLocationDetails: agentMappedLocationDetails,
                            assignAllLocs: row.assignAllLocs,
                            mappedLocations: row.mappedLocations,
                            hiddenLocations: row.hiddenLocations,
                            // primaryLocations: getLocationsAsCSV(row.primary_location) + "," + getLocationsAsCSV(row.secondary_location)
                            primaryLocations: primaryAndSecondaryLocations(getLocationsAsCSV(row.primary_location), getLocationsAsCSV(row.secondary_location))
                        }}
                    >
                        <i
                            className="bi bi-pencil-square text-primary m-1 app-link-color"
                            style={{ fontSize: 24 }}
                        ></i>
                    </Link>
                    {/* <i
                        className="bi bi-trash-fill text-danger m-1 hover cursor-pointer"
                        onClick={(e) => {
                            handleDelete(e, row._id, row.name);
                        }}
                        style={{ fontSize: 24 }}
                    ></i> */}
                </div>
            ),
        },
    ];

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <FilterComponent
                onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

    const filteredItems = data.filter(
        (item: any) =>
            JSON.stringify([
                item.name, item.email, item.display_name,
                item.primary_location.map((item: any) => (item.name)),
                item.secondary_location.map((item: any) => (item.name)),
                (item.isActive ? "active" : "Inactive")
            ])
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    return (
        <Container fluid>
            <TopHeader
                heading="Agents"
                to={constant.AGENT_CREATE}
                action="Add"
                className="bi bi-plus-lg"
                id="agent-create"
            />
            <div>
                <TableComponent
                    data={data}
                    columns={columns}
                    subHeaderComponent={subHeaderComponent}
                    filteredItems={filteredItems}
                    deleteMsg={deleteMsg}
                    deleteMsgtimeout={deleteMsgtimeout}
                    showLoader={showLoader}
                />
            </div>
        </Container>
    );
};

export default Agentlist;
